import type { AccordionProps } from "./Accordion.d";

export default function Accordion({
  accordionBlocks,
}: {
  accordionBlocks: AccordionProps;
}) {
  let classNameAccordion = "";

  if (accordionBlocks.type == "accordion") {
    classNameAccordion = "accordion";
  }

  return accordionBlocks.listAccordion.length ? (
    <>
      {accordionBlocks.title && <h2>{accordionBlocks.title}</h2>}
      {accordionBlocks.subTitle && (
        <h3 className="text-large">{accordionBlocks.subTitle}</h3>
      )}

      <div className={classNameAccordion}>
        {accordionBlocks.listAccordion.map((item, index) =>
          item.content && item.content !== "" ? (
            <details key={index}>
              <summary>{item.title}</summary>
              <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
            </details>
          ) : (
            <div key={index}>{item.title}</div>
          ),
        )}
      </div>
    </>
  ) : (
    <p>Add some items!</p>
  );
}
